export const SERVER_IP = 'https://auth.tmttransport.in/v1/';
// export const SERVER_IP = "http://localhost:3202/v1/";
export const SHOW_API_NAME_IN_NOTIFICATION = true;
export const NOTIFICATION_DURATION = 5;
